import { useTranslation } from '../../hooks/useTranslation';
import { forwardRef } from 'preact/compat';
import './ImageUpload.less';
import useAppDispatch from '../../hooks/useAppDispatch';

const ImageUpload = forwardRef<HTMLInputElement>((_, ref) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    return (
        <input
            className={`bri-ImageUpload`}
            type="file"
            ref={ref}
            onChange={event => {
                const currentTarget = event.currentTarget;
                if (currentTarget.files?.length) {
                    const file = currentTarget.files[0];
                    if (!file.type.startsWith('image/')) {
                        return dispatch.productSearchByImageMainFeatureHandler.setUploadImageError(
                            {
                                message: t(
                                    'PRODUCT_SEARCH_BY_IMAGE_INVALID_IMAGE'
                                )
                            }
                        );
                    }

                    const reader = new FileReader();
                    reader.onload = e => {
                        if (typeof e.target?.result === 'string') {
                            return dispatch.featureState.startFeature({
                                featureType: 'product-search-by-image',
                                imageDataUrl: e.target.result
                            });
                        }
                    };
                    reader.onerror = () => {
                        return dispatch.productSearchByImageMainFeatureHandler.setUploadImageError(
                            { message: '' }
                        );
                    };
                    reader.readAsDataURL(file);
                }
            }}
            accept="image/*"
            multiple={false}
        />
    );
});

export default ImageUpload;
